export default {
  apiKey: "AIzaSyAWwEeXwidMFlvGeWYhZFo9_fGgpnusi6w",
  authDomain: "fyr-backend.firebaseapp.com",
  databaseURL: "https://fyr-backend.firebaseio.com",
  projectId: "fyr-backend",
  storageBucket: "fyr-backend.appspot.com",
  messagingSenderId: "415496750092",
  appId: "1:415496750092:web:c16a4fd7bbf6e150515a29",
  measurementId: "G-LVE8HZRQGX"
};
